import { toFiniteNumber } from "@/lib/ai/visualization/shared/primitives";

/**
 * unknown 値を `Record<string, unknown>` として扱えるか判定する。
 */
export function isRecord(value: unknown): value is Record<string, unknown> {
  return typeof value === "object" && value !== null;
}

/**
 * 数値/数値文字列を有限 number へ変換する。
 */
export function toNumber(value: unknown): number | null {
  return toFiniteNumber(value);
}

/**
 * 非空文字列として扱える値を抽出する。
 */
export function toString(value: unknown): string | null {
  if (typeof value === "string" && value.trim().length > 0) return value;
  if (typeof value === "number" && Number.isFinite(value)) return String(value);
  return null;
}

/**
 * 候補から最初の非空文字列を返す。
 */
export function pickFirstNonEmpty(
  ...values: Array<string | null | undefined>
): string | null {
  for (const value of values) {
    if (value && value.length > 0) return value;
  }
  return null;
}

/**
 * オブジェクトの指定キーが配列なら返し、違う型なら空配列を返す。
 */
export function extractArray(
  output: Record<string, unknown>,
  key: string,
): unknown[] {
  const value = output[key];
  return Array.isArray(value) ? value : [];
}
